const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом запуске страницы

  START: "Расшифруй загадку", //начало игры после нажатия "Начать игру" и при "играть ещё"

  //сообщения ввода строк и реакция при проверке
  ENTER_LINE: "Введите текст для проверки", // если строка ввода строчек пустая
  LINE_CORRECT: "Верно", // отгаданная строка верная
  LINE_WRONG: "Неверно! Попробуй ещё раз", //если предложение в строке не верное
  ALL_LINES_CORRECT: "Загадка расшифрована! Напиши ответ", // все строчки расшифрованы

  //сообщения ввода разгадки (ответа)
  ENTER_ANSWER: "Введите ответ для проверки", // если пустое поле ввода ответа
  ANSWER_WRONG: "Неверный ответ! Попробуйте ещё раз", // если ответ на загадку неверный

  ROUND_FINISHED: "Поздравляем! Вы разгадали загадку. Нажми «Далее»", // когда загадка правильная разгадана
  GAME_FINISHED: "Все загадки разгаданы! Нажми «Играть ещё»", // когда все раунды с загадками разгаданы
} as const;

export default MESSAGES;